import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';

/**
 * Sets the position of the initial mouse click to be used when drag starts to compute the drag offset
 * @param surfaceStore The surface store
 * @param positionX The page x position where the user clicked on the item
 * @param positionY The page y position where the user clicked on the item
 */
export let setDragStartPosition = action('setDragStartPosition')(function setDragStartPosition(
    surfaceStore: CalendarSurfaceStore,
    positionX: number,
    positionY: number
): void {
    let { dragDropState } = surfaceStore;
    dragDropState.dragStartPosition = { x: positionX, y: positionY };
});
